import { useEffect } from "react"
import { useLocation } from "react-router-dom"

// Component that sets scroll to top of window when changing page with react-router
export default function ScrollToTop() {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}



// WEBPACK FOOTER //
// ./src/components/ScrollToTop/index.js